function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.1723 7.88639C45.0884 7.88639 44.0308 8.15187 43.1145 8.6546C42.7399 8.85983 42.3922 9.10197 42.0772 9.37423V1.43005H38.439V25.9566H42.0776V24.6416C42.3987 24.9259 42.753 25.1816 43.1283 25.3974C44.0656 25.9355 45.1184 26.2202 46.1726 26.2202C48.4907 26.2202 50.4197 25.3247 51.7513 23.6301C53.0228 22.0124 53.6948 19.7383 53.6948 17.0533C53.6948 14.3687 53.0228 12.0942 51.7513 10.4765C50.4194 8.78188 48.4904 7.88639 46.1723 7.88639ZM45.9311 11.5949C47.1581 11.5949 48.1837 12.104 48.8964 13.0673C49.6156 14.0396 49.9958 15.4178 49.9958 17.0533C49.9958 18.6887 49.6156 20.067 48.8964 21.0393C48.1837 22.0026 47.1581 22.5117 45.9311 22.5117C44.7041 22.5117 43.6785 22.0026 42.9659 21.0393C42.2466 20.067 41.8665 18.6887 41.8665 17.0533C41.8665 15.4178 42.2466 14.0396 42.9659 13.0673C43.6785 12.104 44.7038 11.5949 45.9311 11.5949Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M63.0795 8.15015H54.7939V11.7927H59.4408V22.3142H54.1906V25.9568H68.6919V22.3142H63.0795V8.15015Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.0791 7.1813C61.7955 7.1813 62.4592 6.8936 62.9477 6.37092C63.4413 5.84297 63.7132 5.12145 63.7132 4.33893C63.7132 2.708 62.5562 1.43066 61.0791 1.43066C59.6019 1.43066 58.4449 2.708 58.4449 4.33893C58.4449 5.12145 58.7168 5.84297 59.2104 6.37092C59.6992 6.89323 60.3629 7.1813 61.0791 7.1813Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M73.3799 0.94043L69.7416 3.44652V8.15029H65.698V11.8588H69.7413V19.8534C69.7413 21.9223 70.2404 23.5208 71.2253 24.605C72.1988 25.6767 73.621 26.2205 75.4531 26.2205C77.5442 26.2205 79.0124 25.5491 80.5206 23.9031L80.7869 23.6124L79.3653 20.0579L78.792 20.7263C77.5166 22.2134 76.569 22.512 75.4531 22.512C74.7494 22.512 74.2478 22.3158 73.9198 21.9118C73.5617 21.4712 73.3799 20.7451 73.3799 19.7547V11.8588H80.8027V8.15029H73.3799V0.94043Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91.4462 7.88672C90.3068 7.88672 89.1743 8.24032 88.1711 8.90987C87.6889 9.23146 87.2408 9.62234 86.8382 10.0693V8.15032H83.1996V25.9569H86.8382V18.6676C86.8382 16.4842 87.268 14.6424 88.0811 13.3417C88.7852 12.2154 89.7338 11.5952 90.7521 11.5952C92.311 11.5952 93.0064 12.4557 93.0064 14.3856V25.9569H96.6451V13.7925C96.6451 11.9959 96.2152 10.5645 95.3677 9.53912C94.4615 8.44254 93.142 7.88672 91.4462 7.88672Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M110.557 9.51577C109.436 8.43463 107.849 7.88672 105.839 7.88672C104.335 7.88672 102.946 8.35969 101.821 9.25405C100.678 10.1635 99.8693 11.4619 99.483 13.0081L99.3374 13.5907L102.61 14.5562L102.773 14.0124C103.219 12.5212 104.394 11.5952 105.839 11.5952C106.717 11.5952 107.445 11.8155 107.944 12.2327C108.504 12.7008 108.788 13.4363 108.788 14.4184V14.5404H106.262C104.001 14.5404 102.209 15.025 100.936 15.9804C100.254 16.4925 99.7289 17.138 99.375 17.8994C99.0135 18.677 98.83 19.5782 98.83 20.5776C98.83 22.343 99.3791 23.8101 100.418 24.8197C101.347 25.7227 102.651 26.2198 104.089 26.2198C106.04 26.2198 107.886 25.5088 109.106 24.3429L109.356 25.9566H112.426V14.8797C112.426 12.5155 111.797 10.711 110.557 9.51577ZM107.315 21.5168C106.555 22.14 105.495 22.512 104.481 22.512C103.241 22.512 102.529 21.8071 102.529 20.5783C102.529 19.8361 102.8 19.249 103.334 18.8333C103.936 18.3652 104.865 18.1174 106.02 18.1174H108.787C108.771 19.5853 108.276 20.729 107.315 21.5168Z",
  fill: "white"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M128.357 22.7123C127.39 21.8582 126.004 21.4255 124.239 21.4255H120.286C119.571 21.4255 119.19 21.2854 118.996 21.168C118.782 21.0384 118.695 20.8867 118.695 20.6445C118.695 20.106 119.096 19.798 119.513 19.5924C120.347 20.013 121.296 20.2258 122.337 20.2258C123.983 20.2258 125.475 19.6417 126.538 18.5817C127.664 17.4576 128.26 15.8929 128.26 14.0564C128.26 13.1383 128.11 12.2982 127.813 11.5507L130.396 10.0911L128.718 6.76367L125.331 8.66499C124.415 8.15511 123.386 7.88699 122.337 7.88699C120.694 7.88699 119.203 8.47557 118.136 9.54429C117.009 10.6725 116.414 12.2326 116.414 14.0564C116.414 15.2667 116.636 16.2992 117.091 17.1906C116.574 17.5024 116.137 17.9223 115.804 18.4284C115.354 19.1141 115.116 19.926 115.116 20.7763C115.116 21.7995 115.388 22.6464 115.926 23.3024C115.098 24.2178 114.634 25.4827 114.634 26.8704C114.634 27.8649 114.816 28.7631 115.176 29.5395C115.531 30.3055 116.06 30.9555 116.747 31.4717C118.044 32.4467 119.884 32.9408 122.216 32.9408C124.225 32.9408 126.06 32.4478 127.38 31.5531C129.021 30.4407 129.889 28.7303 129.889 26.6068C129.89 24.9201 129.374 23.61 128.357 22.7123ZM119.118 24.8972C119.541 24.9683 120.014 25.0018 120.588 25.0018H124.178C124.897 25.0018 125.4 25.1363 125.715 25.4127C126.035 25.694 126.191 26.1703 126.191 26.87C126.191 27.59 125.883 28.1647 125.275 28.5778C124.581 29.0489 123.524 29.2978 122.217 29.2978C120.962 29.2978 119.93 29.0451 119.233 28.5665C118.596 28.1297 118.273 27.5256 118.273 26.771C118.273 25.8616 118.527 25.2899 119.118 24.8972ZM124.009 16.0044C123.596 16.4262 123.018 16.6491 122.338 16.6491C121.677 16.6491 121.087 16.4198 120.676 16.0029C120.229 15.5495 119.992 14.8766 119.992 14.0564C119.992 13.2362 120.229 12.5633 120.676 12.1099C121.087 11.6934 121.677 11.4637 122.338 11.4637C123.018 11.4637 123.596 11.6866 124.009 12.1084C124.449 12.5584 124.682 13.2321 124.682 14.0564C124.682 14.8807 124.449 15.5544 124.009 16.0044Z",
  fill: "white"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5242 28.7912V27.4272C19.8532 27.4272 25.0025 22.2779 25.0025 15.9489H26.3666C26.3672 23.03 20.6059 28.7912 13.5242 28.7912Z",
  fill: "white"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.04571 15.947H0.681641C0.681641 8.86589 6.44291 3.10461 13.524 3.10461V4.46869C7.195 4.46869 2.04571 9.61797 2.04571 15.947Z",
  fill: "white"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5241 24.0401C9.06256 24.0401 5.43286 20.4104 5.43286 15.9489H6.79693C6.79693 19.6583 9.81465 22.6767 13.5241 22.6767V24.0401Z",
  fill: "white"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.6161 15.9484H20.252C20.252 12.239 17.2343 9.22125 13.5242 9.22125V7.85718C17.9864 7.85718 21.6161 11.4869 21.6161 15.9484Z",
  fill: "white"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5247 19.9429C15.7303 19.9429 17.5184 18.1549 17.5184 15.9492C17.5184 13.7436 15.7303 11.9556 13.5247 11.9556C11.319 11.9556 9.53101 13.7436 9.53101 15.9492C9.53101 18.1549 11.319 19.9429 13.5247 19.9429Z",
  fill: "white"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5241 29.4724C6.06693 29.4724 0 23.4055 0 15.9476H2.72814C2.72814 21.9006 7.57177 26.7442 13.5248 26.7442V29.4724H13.5241Z",
  fill: "white"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.0489 15.9479H24.3208C24.3208 9.99493 19.4772 5.1513 13.5242 5.1513V2.42383C20.982 2.42383 27.0489 8.49076 27.0489 15.9479Z",
  fill: "white"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5242 24.7213V21.9931C16.8576 21.9931 19.5697 19.2811 19.5697 15.9476H22.2978C22.2978 20.7859 18.3618 24.7213 13.5242 24.7213Z",
  fill: "white"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.47851 15.9488H4.75037C4.75037 11.1112 8.6864 7.17517 13.524 7.17517V9.90331C10.1906 9.90331 7.47851 12.6154 7.47851 15.9488Z",
  fill: "white"
});

var SvgHeaderLogoInverted = function SvgHeaderLogoInverted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 132,
    height: 34,
    viewBox: "0 0 132 34",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHeaderLogoInverted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/headerLogoInverted.7658792e.svg";
export { ForwardRef as ReactComponent };